@if (loading()) {
  <div class="tc-activity__loading">
    <mat-spinner diameter="24" />
  </div>
} @else if (loadError()) {
  <p class="tc-activity__hint tc-activity__hint--error" role="alert">
    {{ 'testCases.form.activity.loadError' | translate }}
  </p>
} @else if (items().length === 0) {
  <p class="tc-activity__hint">{{ 'testCases.form.activity.empty' | translate }}</p>
} @else {
  <ul class="tc-activity__list">
    @for (item of items(); track item.id) {
      <li class="tc-activity__item">
        <span class="tc-activity__icon tc-activity__icon--{{ item.tone }}" aria-hidden="true">
          @switch (item.icon) {
            @case ('plus') {
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 5v14M5 12h14" />
              </svg>
            }
            @case ('pencil') {
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
              </svg>
            }
            @case ('link') {
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" />
                <path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" />
              </svg>
            }
            @case ('check') {
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
            }
            @case ('cross') {
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            }
            @case ('comment') {
              <svg
                viewBox="0 0 24 24"
                width="14"
                height="14"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z" />
              </svg>
            }
          }
        </span>
        <div class="tc-activity__body">
          <div class="tc-activity__title">
            {{ item.titleKey | translate: item.params }}
          </div>
          <div class="tc-activity__meta">
            <span class="tc-activity__author">{{ item.createdByName || ('common.unknownUser' | translate) }}</span>
            <span aria-hidden="true">·</span>
            <time class="tc-activity__date" [attr.datetime]="item.createdAt">{{ item.createdAt | date: 'short' }}</time>
          </div>
        </div>
      </li>
    }
  </ul>
  @if (truncated()) {
    <p class="tc-activity__hint tc-activity__truncated">{{ 'testCases.form.activity.truncated' | translate }}</p>
  }
}
